export default {
  manufacturerDeleteTitle: "Delete manufacturer",
  manufacturerDeleteMessage: "Do you really want to delete this manufacturer?",
  manufacturerDeleteNotPossibleTitle: "Manufacturer that is associated with asset models can't be deleted.",
};
